import React from 'react';
import DateUtils from '#/lib/DateUtils';
import {FiAlignJustify, FiClock} from 'react-icons/fi';
import {Link} from "react-router-dom";

const comunicatiBaseRelativeUrl = window.location.pathname.includes('backoffice') ? 'comunicato/' : ("/frontoffice/comunicato/");

class ComunicatoItemPrimoPiano extends React.Component {

	getPreview(data){
		return data;
	}

	render() {
		let data = this.props.jsonData;
		let imgUrl = this.props.imageBase64;

		console.warn("END NOW: ", Date.now());
		const marginBottomPrimoPiano = ( window.location.pathname.includes('comunicato')) ? '0.7rem' : '0rem';
		return (
			<>
				<div className="card item-card" style={{ marginBottom: marginBottomPrimoPiano, border: 'none', boxShadow: '0 3px 6px rgba(0, 0, 0, 0.2)'}}>
						<div className="card-body">
						<div className="container">

							<div className="row d-flex">
								<div className='col-12 col-xl-4 d-flex align-items-center justify-content-center mb-2 mb-xl-0'>
									<img
										src={imgUrl}
										alt=''
										align="center"
										className='img-fluid'>
									</img>
								</div>
								<div className="col-12 col-xl-8">
									<div className="card-title">
										<h4><Link to={comunicatiBaseRelativeUrl + this.props.id}>{this.props.title}</Link></h4>
									</div>
									<div className="card-categories d-flex flex-column">
										<span className="icon-span"> <FiAlignJustify /> Categoria: {data.category}</span>
										<span className="icon-span"> <FiClock /> Pubblicato: {DateUtils.epochToDate(this.props.createdAt)} </span>
									</div>
									<div className="card-link">
										<span >{this.props.subtitle}</span>
										<Link className="link-text" to={comunicatiBaseRelativeUrl + this.props.id}> Leggi di più -&#62; &nbsp;</Link>
									</div>
								</div>
							</div>

							{/*Visualizzazione Verticale */}
							{/*<div className="row d-xl-none">
								<div className="col-12 d-flex align-items-center justify-content-center">
									<img
										className="img-fluid"
										src={imgUrl}
										alt=''
										align="left">
									</img>
								</div>
								<div className="col-12" >
									<div >
										<span className="icon-span"> <FiAlignJustify /> Categoria: {this.props.category}</span>
									</div>
									<div>
										<div>
											<span className="icon-span"> <FiClock /> Pubblicato: {DateUtils.epochToDate(this.props.createdAt)} </span>
										</div>
									</div>
									<div >
										<span >{this.props.subtitle}</span>
										<Link className="link-text" to={comunicatiBaseRelativeUrl + this.props.id}> Leggi di più -&#62; &nbsp;</Link>
									</div>
								</div>
							</div>*/}
						</div>
					</div>
				</div>
			</>
		)
	}
};

export default ComunicatoItemPrimoPiano;
